import React, { useState } from "react";
import { Layout } from "../../components/layout/Layout";
import { PageHeader } from "../../components/layout/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";
import { getCommunicationSummary } from "../../services/api/communicationLearning";
import { Link } from "react-router-dom";
import { ROUTES } from "../../utils/constants";

export default function ParentCommunicationProgressPage() {
  const [childId, setChildId] = useState("");
  const [summary, setSummary] = useState<Record<string, unknown> | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const load = async () => {
    if (!childId.trim()) return;
    setErr(null);
    try {
      const s = await getCommunicationSummary(childId.trim());
      setSummary(s);
    } catch {
      setSummary(null);
      setErr("Could not load summary (parent tokens may require a future backend extension).");
    }
  };

  return (
    <Layout>
      <PageHeader
        title="Child’s communication progress"
        subtitle="Friendly overview when your school enables parent access to summaries."
      />
      <div className="max-w-3xl mx-auto px-4 py-8 space-y-4">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Linked learner</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-slate-600">
              Manage linked children from{" "}
              <Link className="text-purple-700 underline" to={ROUTES.PARENT_CHILDREN}>
                Children
              </Link>
              . Enter a learner user id to try the summary API.
            </p>
            <div className="flex gap-2">
              <input
                className="flex-1 px-3 py-2 rounded-lg border border-slate-200"
                placeholder="Child user id"
                value={childId}
                onChange={(e) => setChildId(e.target.value)}
              />
              <Button variant="outline" size="sm" onClick={() => void load()}>
                Load
              </Button>
            </div>
            {err && <p className="text-sm text-amber-800 bg-amber-50 border border-amber-100 rounded-lg p-2">{err}</p>}
            {summary && (
              <pre className="text-xs bg-slate-900 text-slate-100 p-3 rounded-lg overflow-auto max-h-72">
                {JSON.stringify(summary, null, 2)}
              </pre>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
